import TheHome from './TheHome';

export default TheHome;
